import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import { sanitizeUrl } from 'javascripts/sanitizer';
import React from 'react';

const AvatarContents: React.FC<CardContentsComponent<'avatar'>> = ({
  avatar,
}) => {
  const { src, name } = avatar;

  return (
    <aha-avatar src={src ? sanitizeUrl(src) : null} size={16} name={name} />
  );
};

export default AvatarContents;
